import { Component, OnInit, Input } from '@angular/core';
import { NavController, Platform, ModalController, ToastController,}  from '@ionic/angular';
import { Router, ActivatedRoute }             from '@angular/router';

@Component({
  selector: 'app-send-messages-modal',
  templateUrl: './send-messages-modal.page.html',
  styleUrls: ['./send-messages-modal.page.scss'],
})
export class SendMessagesModalPage implements OnInit {

    // "value" passed in componentProps
    // @Input() modalController: ModalController;
    //  public enteredNumberList :any = [];
    @Input() selectedNumber: any = [];
    enteredPhoneNumber            : any = String;
    enteredFirmName               : any = String;
    private resetBackButton       : any;
    
    
  constructor(private route      : ActivatedRoute,
          private router         : Router,
          public platform        : Platform,
          public navCtrl         : NavController, 
          public toastController : ToastController,
          public modalController : ModalController) { 
      
      var self =this;
      this.selectedNumber  = self.route.snapshot.params['selectedNumber'];
  }

  ngOnInit() {
  }
  
//ionViewDidEnter
  ionViewDidEnter() {
      if (this.resetBackButton) {
          this.resetBackButton();
      }
  }
  
  //ionViewWillLeave
  ionViewWillLeave() {
      if (this.resetBackButton) {
          this.platform.backButton.unsubscribe();
          this.resetBackButton = null;
      }
  }
  
  ionViewDidLoad() {
  }
  
  addOrRemoveNumberToSendMessage(checked, phoneNumber, firmName) {
      if (checked) {
          var object = {
            firmName,
            phoneNumber
          }
          this.selectedNumber.push(object);
          this.enteredPhoneNumber = '';
          this.enteredFirmName ='';
          // this.enteredNumberList.push(phoneNumber);
          
          // show toast
          this.presentToast('Phone number added', 'bottom', 2000);
      } else {

        var object = {
            firmName,
            phoneNumber
          }
          // for selectedNumber
          const index = this.selectedNumber.indexOf(object);
          this.selectedNumber.splice(index, 1);
          
          // show toast
          this.presentToast('Phone number removed', 'bottom', 2000);
      }
  }
  
  removeNumberEntered(phoneNumber, firmName) {
      this.addOrRemoveNumberToSendMessage(false, phoneNumber, firmName);
  }
  
  numberEntered(event) {
      this.enteredPhoneNumber = event.detail.value;
  }
  
  firmNameEntered(event) {
      this.enteredFirmName = event.detail.value;
  }
  
  phoneNumberEntered() {
      if (this.enteredPhoneNumber) {
          const enteredPhoneNumber = this.enteredPhoneNumber.toString().replace(/\s/g, '');
          var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

          if (enteredPhoneNumber.length == 10 && enteredPhoneNumber.match(phoneno)) {
            if (this.enteredFirmName) {
              this.addOrRemoveNumberToSendMessage(true, Number(enteredPhoneNumber), this.enteredFirmName );
              this.enteredPhoneNumber = '';
              this.enteredFirmName ='';
            }  else {
                // show toast
                this.presentToast('Please enter firm name', 'top');
            }

          } else {
              // show toast
              this.presentToast('Please enter 10 digit phone number', 'top');
          }
      } else {
          // show toast
          this.presentToast('Please enter 10 digit phone number', 'top');
      }
  }
  
  async presentToast(text, position: any = 'bottom', duration: any = 3000) {
      const toast =  await this.toastController.create({
          message  : text,
          position: 'bottom',
          duration : duration
      });
      toast.present();
  }
  
   dismissModal() {
      // Dismiss the top modal returning some data object
      var self = this;
       self.modalController.dismiss({
          'selectedNumber': this.selectedNumber
      });
  }
  
}
